module.exports = __webpack_public_path__ + "314c657ebb0f498de125190a124c4234.svg";